import React from 'react';

const ForbiddenPage: React.FC = () => {
  return <div>YOU DO NOT HAVE PERMISSION TO SEE THIS PAGE</div>;
};

export default ForbiddenPage;
